import axios from "axios"

const axiosConfig = {
    baseURL: process.env.VUE_APP_SERVER_URL, //"https://pia-test.simcog.de:443",
    timeout: 300000,
};

export default axios.create(axiosConfig);
